import { CheckIcon } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui'
import type {
  CaseDocument,
  Filing,
} from '@/modules/tools/bankruptcy/stores/types'
import { DocumentsManager } from './DocumentsManager'
import { DocumentsPanel } from './DocumentsPanel'

interface DocumentsSummaryProps {
  filing: Filing
  documents: CaseDocument[]
  frozen: boolean
}

const plural = (count: number, noun: string) =>
  `${count} ${noun}${count === 1 ? '' : 's'}`

export const DocumentsSummary = ({
  filing,
  documents,
  frozen,
}: DocumentsSummaryProps) => {
  const [managing, setManaging] = useState(false)

  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between gap-3 rounded-lg border p-4">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
            <CheckIcon className="h-3 w-3" strokeWidth={3} />
          </span>
          <span className="font-medium">Documents</span>
          <span className="text-muted-foreground text-sm">
            {plural(documents.length, 'file')} ·{' '}
            {plural(filing.numberOfPages, 'page')}
          </span>
        </div>
        <Button theme="ghost" size="sm" onClick={() => setManaging((v) => !v)}>
          {managing ? 'Done' : frozen ? 'View' : 'Manage'}
        </Button>
      </div>

      {managing &&
        (frozen ? (
          <DocumentsPanel filingId={filing.id} documents={documents} readOnly />
        ) : (
          <DocumentsManager filing={filing} documents={documents} />
        ))}
    </section>
  )
}
